import { Box } from '@wix/design-system';
import { CollapseList } from '@wix/rules-panel-ui';
import React, { useMemo, useState } from 'react';
import { usePanelStateAtom } from '../../../../../hooks/rules-state';
import { PageListItemButton } from '../page-list-item/page-list-item-button-wrapper';
import { PageListItemCollapsible } from '../page-list-item/page-list-item-collapsible-wrapper';
import { CollapseActionsProvider, ItemScopeProvider } from './context/collapse-actions-context';
export const PageList = props => {
  const {
    getGroupData
  } = usePanelStateAtom();
  const [openItems, setOpenItems] = useState(new Set());
  const {
    pageIds
  } = props;
  const isSpecific = props.isSpecificPageList === true;
  const ruleResultsMap = isSpecific ? props.ruleResultsMap : undefined;
  const isAllCrossPageIssuePassed = isSpecific ? props.isAllCrossPageIssuePassed : undefined;
  const pages = useMemo(() => {
    return pageIds.map(pageId => {
      const pageData = getGroupData(pageId);
      if (!pageData) {
        return null;
      }
      const isPageOpen = openItems.has(pageId);
      return pageData.isTpaPage ? /*#__PURE__*/React.createElement(ItemScopeProvider, {
        id: pageId,
        key: pageId
      }, /*#__PURE__*/React.createElement(PageListItemButton, {
        isPageOpen: isPageOpen,
        pageId: pageId
      })) : /*#__PURE__*/React.createElement(ItemScopeProvider, {
        id: pageId,
        key: pageId
      }, /*#__PURE__*/React.createElement(PageListItemCollapsible, {
        isAllCrossPageIssuePassed: isAllCrossPageIssuePassed,
        isPageOpen: isPageOpen,
        isSpecificPageList: isSpecific,
        pageId: pageId,
        ruleResults: ruleResultsMap == null ? void 0 : ruleResultsMap.get(pageId)
      }));
    }).filter(Boolean);
  }, [getGroupData, isAllCrossPageIssuePassed, isSpecific, openItems, pageIds, ruleResultsMap]);
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(CollapseActionsProvider, {
    setOpenItems: setOpenItems
  }, /*#__PURE__*/React.createElement(CollapseList, {
    contentGap: 0,
    dividerPadding: "0",
    openItems: openItems,
    setOpenItems: setOpenItems
  }, pages)));
};
//# sourceMappingURL=page-list.js.map